function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//

/* eslint-disable no-use-before-define, quote-props, react/forbid-prop-types */
import * as React from 'react';
import PropTypes from 'prop-types';
import Box from "./Box";
import { StyleSheet, css, color, transition } from "../../styles/theme";
import { darken, fade } from "../../utils/colorUtils";
import { dataAttributesFilter } from "../../utils/propProcessors";
import { onKeyPress } from "../../utils/a11yUtils";
var CONFIG = {
  size: {
    sm: {
      fontSize: '0.8rem',
      padding: '0.5rem 1rem',
      minHeight: 36
    },
    md: {
      fontSize: '1rem',
      padding: '0.9rem 2rem',
      minHeight: 48
    },
    lg: {
      fontSize: '1.2rem',
      padding: '1rem 3rem',
      minHeight: 48
    }
  }
};
export var BUTTON_TYPES = {
  primary: 'primary',
  accent: 'accent',
  secondary: 'secondary',
  "default": 'default',
  noStyle: 'noStyle',
  disabled: 'disabled',
  link: 'link',
  icon: 'icon',
  admin: 'admin',
  superUser: 'superUser'
};
export var BUTTON_SIZES = {
  zero: 'zero',
  sm: 'sm',
  md: 'md',
  lg: 'lg'
};
/**
 * A generic Button that accepts children,
 * can be rendered as link, can use together with svgIcons
 * Sample Usage:
 * <Button type="primary" size="sm" label={'sm'}/>
 *
 * <Button isThemeDark={isThemeDark} type="accent">
 *   <SvgMembers isThemeDark={isThemeDark} hoverColor={color.white} />
 * </Button>
 */

export default function Button(props) {
  var _props$rootClassName = props.rootClassName,
    rootClassName = _props$rootClassName === void 0 ? '' : _props$rootClassName,
    children = props.children,
    _props$htmlAttributes = props.htmlAttributes,
    htmlAttributesAlt = _props$htmlAttributes === void 0 ? {} : _props$htmlAttributes,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    _props$customStyles = props.customStyles,
    customStyles = _props$customStyles === void 0 ? {} : _props$customStyles,
    _props$isThemeDark = props.isThemeDark,
    isThemeDark = _props$isThemeDark === void 0 ? false : _props$isThemeDark,
    label = props.label,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _onClick = props.onClick,
    _props$size = props.size,
    size = _props$size === void 0 ? 'md' : _props$size,
    typeAlt = props.type,
    _props$tag = props.tag,
    tag = _props$tag === void 0 ? 'button' : _props$tag,
    _props$isTransparent = props.isTransparent,
    isTransparent = _props$isTransparent === void 0 ? false : _props$isTransparent,
    _props$isChildrenOnRi = props.isChildrenOnRight,
    isChildrenOnRight = _props$isChildrenOnRi === void 0 ? false : _props$isChildrenOnRi,
    _refAlt = props._refAlt;
  var htmlAttributes = htmlAttributesAlt;
  var dynamicStyles = getStyles({
    size: size
  });
  var mergedStyles = _objectSpread(_objectSpread({}, dynamicStyles.Button), style);
  var Tag = tag;
  var isDisabled = disabled || typeAlt === 'disabled' || htmlAttributes.disabled;
  var type = isDisabled ? BUTTON_TYPES.disabled : typeAlt;
  var disabledAttribute = tag === 'button' ? {
    disabled: !!isDisabled
  } : {};
  if (_onClick && tag !== 'button' && tag !== 'a') {
    htmlAttributes.onKeyPress = function (e) {
      return onKeyPress(e, _onClick);
    };
  }
  return /*#__PURE__*/React.createElement(Tag, _extends({}, htmlAttributes, disabledAttribute, {
    ref: _refAlt,
    onClick: function onClick(event) {
      return !isDisabled && _onClick && _onClick(event);
    }
  }, css(rootClassName, styles.Button, styles[type], styles[size], isThemeDark && styles["".concat(type, "ThemeDark")], isThemeDark && styles["".concat(size, "ThemeDark")], tag !== 'button' && (isThemeDark ? styles["".concat(type, "LinkThemeDark")] : styles["".concat(type, "Link")]), isTransparent && styles.isTransparent, StyleSheet.create(customStyles).Button), dataAttributesFilter(props), {
    style: mergedStyles
  }), /*#__PURE__*/React.createElement(Box, {
    alignItems: "center",
    justifyContent: "center",
    tag: "span"
  }, !isChildrenOnRight && children, label, isChildrenOnRight && children));
}

// Explicity declare the default props for documentation purpose,
Button.defaultProps = {
  htmlAttributes: {},
  size: 'md',
  style: {},
  customStyles: {},
  isThemeDark: false,
  disabled: false,
  type: BUTTON_TYPES["default"],
  tag: 'button',
  rootClassName: '',
  isTransparent: false,
  isChildrenOnRight: false
};
Button.propTypes = {
  rootClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /*
  * Aphrodite styles object to provide custom styling
  */
  customStyles: PropTypes.object,
  /**
   * Override the inline-styles of the root element
   */
  style: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  /**
   * Additional control for the root element, can add data-courselenium, ariaLabel...
   */
  htmlAttributes: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  /**
   * Whether button has dark bg parent element
   */
  isThemeDark: PropTypes.bool,
  /**
   * Render the children inside the button, good for icons
   */
  children: PropTypes.node,
  /**
   * The text for the button
   */
  label: PropTypes.node,
  /**
   * click event
   */
  onClick: PropTypes.func,
  /**
   * If disabled, we'll use disabled type
   */
  disabled: PropTypes.bool,
  /**
   * Sometimes you want to remove the background so you can have full control of the styles
   */
  isTransparent: PropTypes.bool,
  /**
   * Render children on the right side if children exists and isChildrenOnRight
   */
  isChildrenOnRight: PropTypes.bool,
  /**
   * Decide the general padding, can be overwritten by style prop
   */
  size: PropTypes.oneOf(Object.keys(BUTTON_SIZES)),
  /**
   * Button types
   */
  type: PropTypes.oneOf(Object.keys(BUTTON_TYPES)),
  /**
   * Allow rendering of different tags, e.g. 'a', 'button', Link
   */
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  /**
   * Dom ref
   */
  _refAlt: PropTypes.func
};

// Dynamic styles
function getStyles(_ref) {
  var size = _ref.size;
  return {
    Button: {},
    icon: {}
  };
}
var basePrimaryStyle = {
  color: color.white,
  backgroundColor: color.primary,
  border: "1px solid ".concat(color.primary),
  ':hover': {
    backgroundColor: color.darkPrimary
  }
};
var styles = StyleSheet.create({
  Button: {
    borderRadius: 2,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'transparent',
    transition: transition.easeOut(),
    lineHeight: '1rem',
    userSelect: 'none',
    position: 'relative',
    textAlign: 'center',
    display: 'inline-block',
    verticalAlign: 'middle',
    whiteSpace: 'nowrap',
    backgroundImage: 'none',
    cursor: 'pointer',
    filter: 'none',
    textDecoration: 'none',
    fontWeight: 600,
    ':hover': {
      textDecoration: 'none !important'
    },
    ':focus': {
      outline: 'auto 2px var(--cds-color-blue-600, rgb(0, 105, 217))',
      textDecoration: 'none !important'
    }
  },
  isTransparent: {
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    ':hover': {
      backgroundColor: 'transparent'
    },
    ':focus': {
      backgroundColor: 'transparent'
    }
  },
  primary: basePrimaryStyle,
  primaryThemeDark: {
    color: color.primary,
    backgroundColor: color.white,
    border: "1px solid ".concat(color.white),
    ':hover': {
      color: color.white,
      backgroundColor: fade(color.white, 0.5),
      borderColor: fade(color.white, 0.5)
    },
    ':focus': {
      color: color.white,
      backgroundColor: fade(color.white, 0.5),
      borderColor: fade(color.white, 0.5)
    }
  },
  admin: _objectSpread(_objectSpread({}, basePrimaryStyle), {}, {
    border: "1px solid ".concat(color.admin),
    backgroundColor: color.admin,
    ':hover': {
      backgroundColor: darken(color.admin, 0.3)
    },
    ':focus': {
      backgroundColor: darken(color.admin, 0.3)
    }
  }),
  superUser: _objectSpread(_objectSpread({}, basePrimaryStyle), {}, {
    backgroundColor: color.superUser,
    border: "1px solid ".concat(color.superUser),
    ':hover': {
      backgroundColor: darken(color.superUser, 0.3)
    },
    ':focus': {
      backgroundColor: darken(color.superUser, 0.3)
    }
  }),
  primaryLink: {
    color: "".concat(color.white, " !important ")
  },
  primaryLinkThemeDark: {
    color: "".concat(color.primary, " !important")
  },
  accent: {
    color: color.white,
    backgroundColor: color.accent,
    borderColor: color.accent,
    ':hover': {
      color: color.white,
      backgroundColor: darken(color.accent, 0.2),
      borderColor: darken(color.accent, 0.2)
    },
    ':focus': {
      color: color.white,
      backgroundColor: darken(color.accent, 0.2),
      borderColor: darken(color.accent, 0.2)
    }
  },
  accentThemeDark: {
    color: color.white,
    backgroundColor: color.accent,
    borderColor: color.accent,
    ':hover': {
      color: color.white,
      backgroundColor: darken(color.accent, 0.2)
    },
    ':focus': {
      color: color.white,
      backgroundColor: darken(color.accent, 0.2)
    }
  },
  accentLink: {
    borderColor: color.accent,
    color: "".concat(color.white, " !important ")
  },
  accentLinkThemeDark: {
    ':hover': {
      color: "".concat(color.white, " !important "),
      backgroundColor: darken(color.accent, 0.2),
      borderColor: darken(color.accent, 0.2)
    },
    ':focus': {
      color: "".concat(color.white, " !important "),
      backgroundColor: darken(color.accent, 0.2),
      borderColor: darken(color.accent, 0.2)
    }
  },
  secondary: {
    color: color.primary,
    backgroundColor: color.white,
    border: "1px solid ".concat(color.primary),
    ':hover': {
      color: color.white,
      backgroundColor: color.darkPrimary
    },
    ':focus': {
      color: color.white,
      backgroundColor: color.darkPrimary
    }
  },
  secondaryThemeDark: {
    color: color.white,
    backgroundColor: 'transparent',
    border: "1px solid ".concat(color.white),
    ':hover': {
      borderColor: fade(color.white, 0.2),
      color: color.white,
      backgroundColor: fade(color.white, 0.2)
    },
    ':focus': {
      borderColor: fade(color.white, 0.2),
      color: color.white,
      backgroundColor: fade(color.white, 0.2)
    }
  },
  secondaryLink: {
    backgroundColor: color.white,
    border: "1px solid ".concat(color.primary),
    ':hover': {
      color: color.white,
      backgroundColor: color.darkPrimary
    },
    ':focus': {
      color: color.white,
      backgroundColor: color.darkPrimary
    }
  },
  secondaryLinkThemeDark: {
    color: "".concat(color.white, " !important"),
    ':hover': {
      backgroundColor: fade(color.white, 0.2),
      borderColor: fade(color.white, 0.2),
      color: "".concat(color.white, " !important ")
    },
    ':focus': {
      backgroundColor: fade(color.white, 0.2),
      borderColor: fade(color.white, 0.2),
      color: "".concat(color.white, " !important ")
    }
  },
  "default": {
    color: color.primaryText,
    backgroundColor: color.white,
    border: "1px solid ".concat(color.bgDarkGray),
    ':hover': {
      color: color.white,
      backgroundColor: color.darkPrimary,
      border: "1px solid ".concat(color.primary)
    },
    ':focus': {
      color: color.white,
      backgroundColor: color.darkPrimary,
      border: "1px solid ".concat(color.primary)
    }
  },
  defaultThemeDark: {
    color: color.primaryText,
    backgroundColor: color.white,
    border: "1px solid ".concat(color.bgDarkGray),
    ':hover': {
      backgroundColor: fade(color.white, 0.2),
      borderColor: fade(color.white, 0.2)
    },
    ':focus': {
      backgroundColor: fade(color.white, 0.2),
      borderColor: fade(color.white, 0.2)
    }
  },
  defaultLink: {
    color: "".concat(color.primaryText, " !important"),
    ':hover': {
      color: "".concat(color.white, " !important")
    },
    ':focus': {
      color: "".concat(color.white, " !important")
    }
  },
  defaultLinkThemeDark: {
    color: "".concat(color.primaryText, " !important"),
    ':hover': {
      backgroundColor: fade(color.white, 0.2),
      color: "".concat(color.white, " !important ")
    }
  },
  noStyle: {
    backgroundColor: 'transparent',
    color: color.primaryText,
    borderColor: 'transparent',
    ':hover': {
      backgroundColor: 'transparent',
      color: color.darkPrimary
    },
    ':focus': {
      backgroundColor: 'transparent',
      color: color.darkPrimary
    }
  },
  noStyleThemeDark: {
    color: color.white,
    borderColor: 'transparent',
    ':hover': {
      color: color.darkPrimary,
      borderColor: color.darkPrimary
    },
    ':focus': {
      color: color.darkPrimary,
      borderColor: color.darkPrimary
    }
  },
  noStyleLink: {
    color: "".concat(color.primaryText, " !important "),
    borderColor: 'transparent',
    ':hover': {
      color: "".concat(color.white, " !important ")
    },
    ':focus': {
      color: "".concat(color.white, " !important ")
    }
  },
  noStyleLinkThemeDark: {
    color: "".concat(color.white, " !important"),
    borderColor: 'transparent',
    ':hover': {
      color: "".concat(color.primary, " !important ")
    },
    ':focus': {
      color: "".concat(color.primary, " !important ")
    }
  },
  icon: {
    color: color.primaryText,
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    ':hover': {
      color: color.primary,
      borderColor: 'transparent'
    },
    ':focus': {
      color: color.primary,
      borderColor: 'transparent'
    }
  },
  iconThemeDark: {
    color: color.white,
    backgroundColor: 'transparent',
    borderColor: 'transparent',
    ':hover': {
      color: "".concat(color.white, " !important "),
      borderColor: 'transparent'
    },
    ':focus': {
      color: "".concat(color.white, " !important "),
      borderColor: 'transparent'
    }
  },
  iconLink: {
    backgroundColor: 'transparent',
    color: "".concat(color.primaryText, " !important "),
    borderColor: 'transparent',
    ':hover': {
      color: "".concat(color.primary, " !important ")
    },
    ':focus': {
      color: "".concat(color.primary, " !important ")
    }
  },
  iconLinkThemeDark: {
    backgroundColor: 'transparent',
    color: "".concat(color.white, " !important"),
    borderColor: 'transparent',
    ':hover': {
      color: "".concat(color.primary, " !important ")
    },
    ':focus': {
      color: "".concat(color.primary, " !important ")
    }
  },
  link: {
    backgroundColor: 'transparent',
    color: color.primary,
    borderColor: 'transparent',
    ':hover': {
      color: color.darkPrimary,
      backgroundColor: 'transparent'
    },
    ':focus': {
      color: color.darkPrimary,
      backgroundColor: 'transparent'
    }
  },
  linkThemeDark: {
    ':hover': {
      color: "".concat(color.white, " !important "),
      backgroundColor: fade(color.white, 0.2),
      borderColor: fade(color.white, 0.2)
    },
    ':focus': {
      color: "".concat(color.white, " !important "),
      backgroundColor: fade(color.white, 0.2),
      borderColor: fade(color.white, 0.2)
    }
  },
  linkLink: {
    color: "".concat(color.primaryText, " !important "),
    ':hover': {
      color: "".concat(color.primary, " !important ")
    },
    ':focus': {
      color: "".concat(color.primary, " !important ")
    }
  },
  linkLinkThemeDark: {
    color: "".concat(color.white, " !important"),
    ':hover': {
      color: "".concat(color.primary, " !important "),
      backgroundColor: fade(color.white, 0.2)
    },
    ':focus': {
      color: "".concat(color.primary, " !important "),
      backgroundColor: fade(color.white, 0.2)
    }
  },
  disabled: {
    backgroundColor: color.disabled,
    border: "1px solid ".concat(color.disabled),
    color: color.disabledText,
    cursor: 'not-allowed !important',
    // TODO(Audrey): remove once fully migrated
    ':hover': {
      backgroundColor: color.disabled,
      borderColor: color.disabledText
    },
    ':focus': {
      backgroundColor: color.disabled,
      borderColor: color.disabledText
    }
  },
  disabledThemeDark: {},
  disabledLink: {
    color: "".concat(color.disabledText, " !important ")
  },
  disabledLinkThemeDark: {
    color: "".concat(color.disabledText, " !important ")
  },
  zero: {
    padding: 0
  },
  sm: {
    padding: CONFIG.size.sm.padding,
    fontSize: CONFIG.size.sm.fontSize,
    minHeight: CONFIG.size.sm.minHeight
  },
  md: {
    padding: CONFIG.size.md.padding,
    fontSize: CONFIG.size.md.fontSize,
    minHeight: CONFIG.size.md.minHeight
  },
  lg: {
    padding: CONFIG.size.lg.padding,
    fontSize: CONFIG.size.lg.fontSize,
    minHeight: CONFIG.size.lg.minHeight
  }
});